export default __webpack_public_path__ + "static/simple-line-a36b21db2223aaefbb7facb61ff07af3.png";